<template>
  <div class="home">
    <NavBar v-on:scroll-to="scrollTo"></NavBar>
    <Hero v-on:scroll-to="scrollTo"></Hero>
    <main>
      <section class="section" id="mainProjects" ref="mainProjects" tabindex="-1">
        <div class="container">
          <div class="column is-full">
            <h3 class="title is-3 has-text-centered" id="focusMain">Main Projects</h3>
            <h4 class="subtitle is-4 has-text-centered">Experience in and out of the classroom</h4>
          </div>
          <br />
          <MainCards></MainCards>
        </div>
      </section>
      <section class="section has-background-dark" id="sideProjects" ref="sideProjects" tabindex="-1">
        <div class="container">
          <div class="column is-full has-text-centered">
            <h3 class="title is-3 has-text-light" id="focusSide">Side Projects</h3>
            <h4 class="subtitle is-4 has-text-light">Fields of Interest with a CS Twist</h4>
          </div>
          <br />
          <SideCards></SideCards>
        </div>
      </section>
      <section class="section" id="contactMe" ref="contactMe" tabindex="-1">
        <ContactMe></ContactMe>
      </section>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Hero from '@/components/Hero.vue'
import MainCards from '@/components/MainProjectCards.vue'
import SideCards from '@/components/SideProjectCards.vue'
import ContactMe from '@/components/ContactMe.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    NavBar,
    Hero,
    MainCards,
    SideCards,
    ContactMe,
    Footer
  },
  methods: {
    scrollTo (sectionName, isOpen = false) {
      let section;
      let currentFocus;
      if(sectionName == "mainProjects") {
        section = this.$refs.mainProjects;
      }
      else if(sectionName == "sideProjects") {
        section = this.$refs.sideProjects;
      }
      else if(sectionName == "contactMe") {
        section = this.$refs.contactMe;
      }
      section.scrollIntoView({behavior: "smooth"});
      section.focus({preventScroll:true});
    }
  }
}
</script>

<style scoped>
  #mainProjects:focus, #sideProjects:focus, #contactMe:focus {
    outline: none;
  }
</style>
